import { app } from '@/main'
import { routerMap } from '@GM/Layout/routerMap'
import { getObjectKey, getStorage } from '@GUTIL/other'
import { paddingZeroLeft } from '@GUTIL/format'

const AuthPageMap = {
  LOGIN: 'Login',
  PASSWORD_FORGET: 'PasswordForget',
  PASSWORD_RESET: 'PasswordReset',
  PASSWORD_RESET_SUCCESS: 'PasswordResetSuccess',
  OTP_BINDING: 'OtpBinding',
  OTP_VERIFY: 'OtpVerify',
  OTP_RESET: 'OtpReset',
  OTP_RESET_SUCCESS: 'OtpResetSuccess'
}

const {
  LOGIN,
  PASSWORD_FORGET,
  PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  OTP_BINDING,
  OTP_VERIFY,
  OTP_RESET,
  OTP_RESET_SUCCESS
} = AuthPageMap

/*
{
  [頁面]: {
    prevPage: [可以進入這個頁面的頁面]
  }...
}
*/
export const authFlow = {
  [PASSWORD_FORGET]: {
    prevPage: [LOGIN]
  },
  [PASSWORD_RESET]: {
    prevPage: [OTP_VERIFY, PASSWORD_FORGET]
  },
  [PASSWORD_RESET_SUCCESS]: {
    prevPage: [PASSWORD_RESET]
  },
  [OTP_BINDING]: {
    prevPage: [LOGIN, OTP_VERIFY]
  },
  [OTP_VERIFY]: {
    prevPage: [LOGIN, OTP_BINDING, OTP_RESET]
  },
  [OTP_RESET]: {
    prevPage: [OTP_VERIFY]
  },
  [OTP_RESET_SUCCESS]: {
    prevPage: [OTP_RESET]
  }
}

export function authRouterCheck(to, from, next) {
  const toPage = to.name
  const fromPage = from.name
  const isFlow = authFlow[toPage].prevPage.includes(fromPage)
  isFlow ? next() : next(LOGIN)
}

//拿取當頁權限
export const getRoutePermission = routeKey => {
  let currentRouterMap = routerMap[process.env.FOLDER_NAME]
  try {
    let currentRouteKey = routeKey
      ? routeKey
      : getObjectKey(currentRouterMap, app.$route.name)
    let allowRoute = getStorage('permission')
    let matchedRouteKey = Object.keys(allowRoute).find(
      allowKey => currentRouteKey.indexOf(allowKey) >= 0
    )
    return allowRoute[matchedRouteKey]
  } catch (e) {
    console.log(e)
  }
}

// 取得登入者的資訊
export const getLoginUser = () => {
  let meInfo = getStorage('me_info')
  return meInfo ? meInfo : {}
}

// Menu Code 格式轉換 XO3.1 => XO3001
export const menuFilter = (menu, key, reverse = false) => {
  menu.forEach(row => {
    let menuID = null

    const filter = code => {
      const pointIndex = code.indexOf('.')
      const subCode = code.slice(pointIndex + 1, code.length)
      const subCodeFilter = paddingZeroLeft(subCode, 3)
      return pointIndex > 0 ? code.slice(0, pointIndex) + subCodeFilter : code
    }

    const filterReverse = code => {
      const subCode = code.slice(-3)
      const payload = code.replace(subCode, '.' + +subCode)
      return payload
    }

    if (reverse) {
      menuID = filterReverse(row[key])
    } else {
      menuID = filter(row[key])
    }
    row[key] = menuID
  })
  return menu
}
